// Roles de staff (admin-users.md). Jerarquía por grants: webmaster > admin > technician > owner.
// `owner` es el rol del portal público de clientes (no accede al staff); se muestra pero
// no es un rol operativo del dashboard.

export const ROLES = ['webmaster', 'admin', 'technician', 'owner'];

export const ROLE_RANK = { owner: 0, technician: 1, admin: 2, webmaster: 3 };

export const ROLE_LABEL = {
    webmaster:  'Webmaster',
    admin:      'Administrador',
    technician: 'Técnico',
    owner:      'Propietario (portal)',
};

// Roles que un usuario con `myRole` puede asignar: ≤ su propio nivel (guard de jerarquía
// del backend, Q-169). Ej.: admin no puede crear/ascender a webmaster.
export function assignableRoles(myRole) {
    const myRank = ROLE_RANK[myRole] ?? -1;
    return ROLES.filter((r) => (ROLE_RANK[r] ?? 99) <= myRank);
}
